// extracted by mini-css-extract-plugin
module.exports = {"likeBtn":"dvrVPQX","likeBtnRow":"cyr9UBd"};